import store from '@/store'
import Configuration from '@/agilis/util/Configuration'
import DocumentEditor from '@/agilis/components/DocumentEditor/DocumentEditor.vue'

export default {
  name: 'PlaygroundDocumentsV2',

  components: {
    DocumentEditor
  },

  data () {
    return {}
  },

  beforeMount () {
    store.commit('contextStore/setSelectedContext', {
      applicationId: this.applicationId,
      workspaceId: this.workspaceId,
      trackerTypeId: this.documentId
    })
  },

  computed: {
    applicationId () {
      return 'playground'
    },

    workspaceId () {
      return 'documentsV2'
    },

    documentId () {
      return 'newSorintAreas'
    },

    document () {
      return Configuration.document.getDocument(this.applicationId, this.documentId)
    }
  }

}
